var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingGray2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 1.5H1.75V36.5H36.75V1.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2686 29.8296C28.2686 24.9953 24.3045 21.0312 19.4702 21.0312C14.636 21.0312 10.6719 24.9953 10.6719 29.8296C16.2796 27.1224 22.7575 27.1224 28.2686 29.8296Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7033 17.0667C14.0916 17.0667 15.2171 15.9412 15.2171 14.5529C15.2171 13.1645 14.0916 12.0391 12.7033 12.0391C11.3149 12.0391 10.1895 13.1645 10.1895 14.5529C10.1895 15.9412 11.3149 17.0667 12.7033 17.0667Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31836 10.4933C9.31836 10.4933 13.8626 9.71979 16.6664 15.1342",
    stroke: "black",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0128 17.0628C28.4012 17.0628 29.5267 15.9373 29.5267 14.549C29.5267 13.1606 28.4012 12.0352 27.0128 12.0352C25.6245 12.0352 24.499 13.1606 24.499 14.549C24.499 15.9373 25.6245 17.0628 27.0128 17.0628Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3969 10.4874C30.3969 10.4874 25.8527 9.71393 23.0488 15.1283",
    stroke: "black",
    strokeWidth: 2.8346,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGray2);
export default __webpack_public_path__ + "static/media/rating-gray-2.21b706753cf1e26b8aa6cfebe1d0c539.svg";
export { ForwardRef as ReactComponent };